/* globalmodule */
define('../src/sublayouts/m79-dashboard-tools/m79-dashboard-tools',['jquery'], function($) {

    'use strict';

    var M79 = function($component) {

        this.$component = $component;
        return this;
    };

    M79.prototype.init = function() {
        var _this = this,
        	date = new Date(),
        	hour = date.getHours(),
        	$greeting = this.$component.find('.m79-dashboard-tools--greeting_wrapper').find('.m79-dashboard-tools--greeting'),
        	$greets = this.$component.find('.m79-dashboard-tools--greeting_wrapper').data('greeting');

        //console.log(hour)

        if (hour < 12) {
        	$greeting.html($greets.morning)
        } else if ((18 > hour) && (hour >= 12)) {
        	$greeting.html($greets.afternoon)
        } else {
        	$greeting.html($greets.evening)
        }
    };

    return M79;

});

